import * as React from 'react';

import classNames from 'classnames';

import GenericIconProps from './icon.type';

export default function ChevronRightIcon({ className = '', viewBox = '0 0 24 24', size }: GenericIconProps) {
  return (
    <svg className={classNames(className, size)} viewBox={viewBox} fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M7.14999 21.1C6.89999 20.85 6.77499 20.5542 6.77499 20.2125C6.77499 19.8708 6.89999 19.575 7.14999 19.325L14.475 12L7.12499 4.65C6.89166 4.41667 6.77499 4.125 6.77499 3.775C6.77499 3.425 6.89999 3.125 7.14999 2.875C7.39999 2.625 7.69583 2.5 8.03749 2.5C8.37916 2.5 8.67499 2.625 8.92499 2.875L17.325 11.3C17.425 11.4 17.4958 11.5083 17.5375 11.625C17.5792 11.7417 17.6 11.8667 17.6 12C17.6 12.1333 17.5792 12.2583 17.5375 12.375C17.4958 12.4917 17.425 12.6 17.325 12.7L8.89999 21.125C8.66666 21.3583 8.37916 21.475 8.03749 21.475C7.69583 21.475 7.39999 21.35 7.14999 21.1Z" />
    </svg>
  );
}
